var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { browserAuthUrl } from 'utils/api/browserAuthApi';
import ForgotPasswordHelpText from './forgotPasswordPage/ForgotPasswordHelpText';
var ForgotPasswordApiError = /** @class */ (function (_super) {
    __extends(ForgotPasswordApiError, _super);
    function ForgotPasswordApiError(message, status) {
        var _this = _super.call(this, message) || this;
        _this.name = 'ForgotPasswordApiError';
        _this.status = status;
        Object.setPrototypeOf(_this, ForgotPasswordApiError.prototype);
        return _this;
    }
    return ForgotPasswordApiError;
}(Error));
export { ForgotPasswordApiError };
var forgotPassword = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(browserAuthUrl('forgot-password'), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(request),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new ForgotPasswordApiError('Kunne ikke sende e-post for tilbakestilling av passord.', response.status);
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
var ForgotPasswordSuccess = function () { return (React.createElement("div", { className: "success" },
    React.createElement("h2", null, "Forsp\u00F8rsel mottatt"),
    React.createElement("p", { className: "forgot_password_valid" }, "Hvis en bruker eksisterer knyttet til adressen du spesifiserte vil vi sende deg en epost som lar deg endre passord p\u00E5 kontoen din. Hvis du ikke mottar e-posten anbefaler vi at du sjekker s\u00F8ppelpost-mappen din og sjekker at eposten du skrev inn over er korrekt."),
    React.createElement("a", { href: "/" }, "Tilbake til hovedsiden"))); };
var ForgotPasswordPage = function () {
    var _a = useState(''), email = _a[0], setEmail = _a[1];
    var _b = useState('idle'), status = _b[0], setStatus = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setStatus('loading');
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, forgotPassword({ email: email })];
                case 2:
                    _a.sent();
                    setStatus('sent');
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    message = err_1 instanceof ForgotPasswordApiError ? err_1.message : 'Noe gikk galt. Prøv igjen';
                    setError(message);
                    setStatus('idle');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "main-content" },
        React.createElement("h1", null, "Glemt Passord"),
        React.createElement("form", { className: 'forgot-password', onSubmit: handleSubmit },
            React.createElement("label", { htmlFor: "email" }, "E-postadresse:"),
            React.createElement("div", { className: "horizontal dense" },
                React.createElement("input", { id: "email", value: email, placeholder: "ola@nordmann.no", type: "email", required: true, onChange: function (e) { return setEmail(e.target.value); } }),
                React.createElement("button", { type: "submit", disabled: status === 'loading' }, "Send"))),
        React.createElement(ForgotPasswordHelpText, null),
        error && React.createElement("p", { className: "error-text" }, error),
        status === 'sent' && React.createElement(ForgotPasswordSuccess, null)));
};
export default ForgotPasswordPage;
